import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

import Store from '@/app/model/Store';

const StoreContext = createContext<Store | null>(null);

export const StoreProvider = ({ children }: PropsWithChildren) => {
  const store = useMemo(() => new Store(), []);
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
};

export const useStore = (): Store => {
  const store = useContext(StoreContext);
  if (!store) throw new Error('useStore must be used within StoreProvider');
  return store;
};
